import React from 'react'
import styles from './Highlights.module.scss'

const Highlights = () => {
    const highlights = [
        {
            img: '/1-green.webp',
            content: '78% (approx 87,000 sq. ft.) of Total Project Area is Green & Open Area.'
        },
        {
            img: '/7-wide-balcony.webp',
            content: '45 feet wide Balconies with Ample Length Space.'
        },
        {
            img: '/2-four-side.webp',
            content: 'Four Side Open Site, Ensuring Air Circulation and Ample Sunlight in every Apartment.'
        },
        {
            img: '/8-club-house.webp',
            content: 'In House Club House 9700 sq. ft. with Lavish Banquet Hall, Indoor Games etc..'
        },
        {
            img: '/3-corner.webp',
            content: '80% Units are Corner Apartments & Minimum Two Side Open.'
        },
        {
            img: '/9-kids-play.webp',
            content: 'Kids Play Zone with Swings and More.'
        },
        {
            img: '/10-commercial.webp',
            content: 'In-House Commercial Market.'
        },
        {
            img: '/5-sunrize.webp',
            content: 'Most of the Apartments are Sunrise/Sunset Facing.'
        },
        {
            img: '/11-walkway.webp',
            content: 'In-House Pedestrian Walkway for the Residents.'
        },
        {
            img: '/6-wide-road.webp',
            content: 'Grand Entrance with 40 ft. Wide Internal Roads.'
        }
    ]
    return (
        highlights?.map((item, index) =>
            <div key={index} className={styles.highlightContainer}>
                <img src={item?.img} className={styles.highlightIcon} alt="highlights"></img>
                <p className={styles.highlightContent}>{item?.content}</p>
            </div>
        )
    )
}

export default Highlights